import {PricingPlanTypes} from 'app/common/enums/billing/PricingPlanTypes.enum';
import {IPricingPlan} from 'app/common/interfaces/billing/pricingPlan';

export const IntelisPricingPlans: IPricingPlan[] = [
  {
    name: 'Basic',
    pricingPlanType: PricingPlanTypes.Basic,
    productsLimit: 100,
    price: 79,
    annualPrice: 790,
    crossedAnnualPrice: 948,
    benefits: [
      { text: 'Up to 100 SKUs', isBold: true },
      { text: 'AI-powered price tracking', isBold: false },
      { text: 'Google Shopping analysis', isBold: false },
      { text: 'Bulk updates', isBold: false },
      { text: 'Unlimited competitors', isBold: false },
      { text: 'Daily reports', isBold: false },
      { text: 'Dynamic pricing', isBold: false },
      { text: 'Chat support', isBold: false },
    ],
  },
  {
    name: 'Premium',
    pricingPlanType: PricingPlanTypes.Premium,
    productsLimit: 1000,
    price: 249,
    annualPrice: 2490,
    crossedAnnualPrice: 2988,
    benefits: [
      { text: 'Up to 2K SKUs', isBold: true },
      { text: 'All Basic features', isBold: true },
      { text: 'Brand/category analytics', isBold: false },
      { text: 'Sales analytics', isBold: false },
      { text: 'Variant tracking', isBold: false },
      { text: 'MAP Monitoring', isBold: false },
      { text: 'API access', isBold: false },
      { text: 'Premium Chat Support', isBold: false },
    ],
  },
  {
    name: 'Business',
    pricingPlanType: PricingPlanTypes.Business,
    productsLimit: 5000,
    price: 499,
    annualPrice: 4990,
    crossedAnnualPrice: 5988,
    benefits: [
      { text: 'Up to 5,000 SKUs', isBold: true },
      { text: 'All Premium features', isBold: true },
      { text: 'Advanced Product Analysis', isBold: false },
      { text: 'Advanced Sales Analysis', isBold: false },
      { text: 'Pricing History', isBold: false },
      { text: 'Pricing Consultant', isBold: false },
      { text: 'A+ Support', isBold: false },
    ],
  },
  {
    name: 'Enterprise',
    pricingPlanType: PricingPlanTypes.Enterprise,
    productsLimit: 10000,
    price: 849,
    annualPrice: 8490,
    crossedAnnualPrice: 10188,
    benefits: [
      { text: 'Up to 10,000 SKUs', isBold: true },
      { text: 'All Business features', isBold: true },
      { text: 'Third-party integrations', isBold: false },
      { text: 'Dedicated account manager', isBold: false },
    ],
  },
  {
    name: 'Custom',
    pricingPlanType: PricingPlanTypes.Custom,
    productsLimit: 100000,
  },
];
